import { useEffect } from 'react';

import { useRecordModal } from 'hooks/useRecordModal';
import { queryClient } from 'providers/queryClient';
import { useImportFileDetails } from 'shared/widgets/RequestsBankOpsImport/hooks/useImportFileDetails';
import { useRemoveImportCacheOnFail } from 'shared/widgets/RequestsBankOpsImport/hooks/useRemoveImportCacheOnFail';
import { useRemoveImportCacheWithDelay } from 'shared/widgets/RequestsBankOpsImport/hooks/useRemoveImportCacheWithDelay';
import { RequestsBankOpsImportResultDialog } from 'shared/widgets/RequestsBankOpsImport/RequestsBankOpsImportResultDialog/RequestsBankOpsImportResultDialog';
import { RequestsBankOpsImportSuccessDialog } from 'shared/widgets/RequestsBankOpsImport/RequestsBankOpsImportSuccessDialog/RequestsBankOpsImportSuccessDialog';
import { ImportFile, ImportFileStatuses } from 'types/embedded/bankOperation';

export const RequestsBankOpsImportDialogs: React.FC = () => {
  const importResultModal = useRecordModal<ImportFile>();
  const importSuccessModal = useRecordModal<ImportFile>();

  const { activeImportStatus, errors, isLoadingErrors, activeImport } = useImportFileDetails();
  useRemoveImportCacheOnFail(activeImport?.id, activeImportStatus);
  const { removeImportCacheWithDelay } = useRemoveImportCacheWithDelay();

  useEffect(() => {
    if (activeImportStatus === ImportFileStatuses.WaitingDecision && activeImport?.errorRows) {
      importResultModal.handleOpenRecordModal();
    }
  }, [activeImportStatus]);

  useEffect(() => {
    if (activeImportStatus === ImportFileStatuses.Saved && activeImport) {
      importSuccessModal.handleOpenRecordModal(activeImport);
      queryClient.invalidateQueries({ queryKey: ['bank_operations/pending_statuses'] });
    }
  }, [activeImportStatus]);

  return (
    <>
      <RequestsBankOpsImportResultDialog
        activeImport={activeImport}
        errors={errors}
        isLoadingErrors={isLoadingErrors}
        onClose={importResultModal.handleCloseRecordModal}
        onSuccess={importSuccessModal.handleOpenRecordModal}
        open={importResultModal.openRecordModal}
      />
      <RequestsBankOpsImportSuccessDialog
        onClose={() => {
          importSuccessModal.handleCloseRecordModal();
          removeImportCacheWithDelay();
        }}
        open={importSuccessModal.openRecordModal}
        record={importSuccessModal.record}
      />
    </>
  );
};
